// MF会計（マネーフォワード会計）仕訳取込用CSV（本城さん確定・Issue #51）
//
// 従来は「MF請求書からCSV出力→MF会計取込用Excelに手で転記」という手作業だった。
// 本城さん指定の必要情報（これだけあれば形式は自由と確認済み）:
//   所属部門 / インボイス登録の有無 / 支払金額 / 個人名（企業所属なら企業名）
//
// 支払先の判定は通知書の宛名ロジック（recipient.ts の noticeRecipient）を再利用する。
// ただし会計データのため敬称（様/御中）は付けない。

import { noticeRecipient } from "./calc/recipient";
import type { Statement } from "../types";

const HEADER = ["対象月", "支払先", "所属部門", "インボイス登録", "登録番号", "支払金額（税込）"];

// CSVの1フィールドをエスケープする（カンマ・引用符・改行を含む場合のみ "..." で囲む）
function escapeCsvField(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function toRow(fields: (string | number)[]): string {
  return fields.map((f) => escapeCsvField(String(f))).join(",");
}

// 支払明細一覧からMF会計取込用CSVの文字列を生成する（改行は \r\n。BOM付与は呼び出し側で行う）
export function buildAccountingCsv(statements: Statement[]): string {
  const lines = [toRow(HEADER)];
  for (const s of statements) {
    const recipient = noticeRecipient(s.org, s.driverName);
    const hasInvoice = !!(s.invoiceNo && s.invoiceNo.trim());
    lines.push(
      toRow([
        s.targetMonth,
        recipient.name,
        s.branch,
        hasInvoice ? "有" : "無",
        s.invoiceNo ?? "",
        s.netTotal,
      ])
    );
  }
  return lines.join("\r\n");
}
